import { useState } from 'react';
import { API } from '../service/ProductsService';

// מי שכבר התחבר מהמכשיר הזה פעם — נפתח על "כניסה"; ביקור ראשון — על "הרשמה"
const HAS_ACCOUNT_KEY = 'has-account';
const MIN_PASSWORD = 6;   // כמו @minPassword ב-spSignUp

const hasAccount = () => {
  try { return localStorage.getItem(HAS_ACCOUNT_KEY) === '1'; } catch (e) { return false; }
};

// ספרות בלבד, 972 → 0 — אותו כלל כמו fnNormalizePhone בשרת (שם זה נבדק שוב)
const normalizePhone = (value) => {
  let p = (value || '').replace(/[^\d]/g, '');
  if (p.startsWith('972')) p = '0' + p.slice(3);
  return p;
};
const isValidPhone = (value) => /^0\d{8,9}$/.test(normalizePhone(value));

const s = {
  page:      { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px' },
  wrap:      { width: '100%', maxWidth: 420 },
  brand:     { textAlign: 'center', marginBottom: 20 },
  logo:      { width: 72, height: 72, borderRadius: 18 },
  title:     { margin: '10px 0 0', fontSize: 30, fontWeight: 700 },
  subtitle:  { margin: '4px 0 0', color: '#59636e' },
  card:      { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 16, padding: 20, boxShadow: '0 8px 24px rgba(0,0,0,.06)' },
  tabs:      { display: 'flex', background: '#f4f5f7', borderRadius: 10, padding: 4, marginBottom: 18 },
  tab:       { flex: 1, padding: '9px 0', border: 'none', borderRadius: 8, background: 'none', color: '#59636e', fontWeight: 600, fontSize: 15 },
  tabActive: { background: '#fff', color: '#1f2328', boxShadow: '0 1px 3px rgba(0,0,0,.12)' },
  row:       { display: 'flex', gap: 10 },
  field:     { flex: 1, marginBottom: 14 },
  label:     { display: 'block', fontSize: 13, color: '#59636e', marginBottom: 4 },
  input:     { width: '100%', padding: '11px 12px', fontSize: 16, border: '1px solid #d0d7de', borderRadius: 10, background: '#fff' },
  ltr:       { direction: 'ltr', textAlign: 'right' },
  hint:      { fontSize: 12, color: '#8c959f', marginTop: 4 },
  check:     { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16, fontSize: 15, cursor: 'pointer' },
  checkbox:  { width: 18, height: 18 },
  error:     { background: '#fff1f0', border: '1px solid #ffccc7', color: '#a8071a', padding: '9px 12px', borderRadius: 10, marginBottom: 14, fontSize: 14 },
  submit:    { width: '100%', padding: '12px', fontSize: 17, fontWeight: 700, border: 'none', borderRadius: 10, background: '#1a3f9c', color: '#fff' },
  switch:    { textAlign: 'center', marginTop: 14, fontSize: 14, color: '#59636e' },
  link:      { background: 'none', border: 'none', color: '#1a3f9c', fontWeight: 600, padding: 0, fontSize: 14 },

  status:        { textAlign: 'center', padding: '8px 4px' },
  statusIcon:    { fontSize: 44, lineHeight: 1 },
  statusTitle:   { margin: '10px 0 8px', fontSize: 22, fontWeight: 700 },
  statusBadge:   { display: 'inline-block', padding: '4px 12px', borderRadius: 999, fontSize: 13, fontWeight: 600, marginBottom: 12 },
  badgePending:  { background: '#fff8c5', color: '#7d4e00' },
  badgeRejected: { background: '#fff1f0', color: '#a8071a' },
  statusText:    { margin: '0 0 12px', color: '#59636e', lineHeight: 1.6 },
  checkedAt:     { margin: '0 0 12px', color: '#8c959f', fontSize: 13 },
};

// סטטוס בקשת הרשמה (spSignUp / spSignIn code 6-7). משתמש חדש ממתין לאישור בבק אופיס לפני שהוא יכול להיכנס
const StatusCard = ({ approval, onCheckAgain, onBack, loading }) => {
  const rejected = approval.status === 'rejected';
  const content = rejected
    ? { icon: '❌', title: 'בקשת ההרשמה נדחתה', text: null }
    : approval.justSignedUp
      ? { icon: '✅', title: 'הבקשה נשלחה!', text: `תודה${approval.firstName ? ` ${approval.firstName}` : ''}, בקשת ההרשמה שלך תאושר בקרוב. ניתן לבדוק בעוד כשעה — נכנסים עם הטלפון והסיסמה.` }
      : { icon: '⏳', title: 'ממתין לאישור', text: 'הבקשה שלך עדיין ממתינה לאישור. ניתן לבדוק שוב בעוד כשעה.' };

  return (
    <div style={s.status} role="status">
      <div style={s.statusIcon} aria-hidden="true">{content.icon}</div>
      <h2 style={s.statusTitle}>{content.title}</h2>
      <div style={{ ...s.statusBadge, ...(rejected ? s.badgeRejected : s.badgePending) }}>
        סטטוס: {rejected ? 'נדחה' : 'ממתין לאישור'}
      </div>
      {content.text && <p style={s.statusText}>{content.text}</p>}
      {rejected && approval.rejectReason && <p style={s.statusText}>סיבה: {approval.rejectReason}</p>}
      {approval.checkedAt && <p style={s.checkedAt}>נבדק עכשיו, {approval.checkedAt}</p>}

      {!rejected && (
        <button type="button" style={s.submit} onClick={onCheckAgain} disabled={loading}>
          {loading ? 'בודק…' : 'בדיקת סטטוס'}
        </button>
      )}
      <div style={s.switch}>
        <button type="button" style={s.link} onClick={onBack}>חזרה לכניסה</button>
      </div>
    </div>
  );
};

// כניסה / הרשמה מהירה. onLogin(token, { firstName, lastName }) — רק למשתמש מאושר.
// הרשמה → ממתין לאישור (StatusCard); כניסה של משתמש ממתין / שנדחה → StatusCard עם הסטטוס.
const AuthPage = ({ onLogin }) => {
  const [mode, setMode] = useState(() => (hasAccount() ? 'signin' : 'signup'));
  const [form, setForm] = useState({ firstName: '', lastName: '', phone: '', password: '', isKfarResident: true });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [approval, setApproval] = useState(null);   // { status, firstName, rejectReason, justSignedUp, checkedAt }

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.type === 'checkbox' ? e.target.checked : e.target.value }));

  const switchMode = (next) => {
    setMode(next);
    setError(null);
  };

  // ולידציה בקליינט — ושוב ב-SP
  const validate = () => {
    if (mode === 'signup' && (!form.firstName.trim() || !form.lastName.trim())) return 'נא להזין שם פרטי ושם משפחה';
    if (!isValidPhone(form.phone)) return 'מספר הטלפון לא תקין';
    if (form.password.length < MIN_PASSWORD) return `הסיסמה צריכה להכיל לפחות ${MIN_PASSWORD} תווים`;
    return null;
  };

  const rememberAccount = () => {
    try { localStorage.setItem(HAS_ACCOUNT_KEY, '1'); } catch (err) { /* חסום */ }
  };

  // כניסה (גם "בדיקת סטטוס" מ-StatusCard): code 0 = מאושר → נכנסים; 6 = ממתין; 7 = נדחה
  const signIn = async () => {
    const resp = await API.signIn(normalizePhone(form.phone), form.password);
    const status = resp?.[0]?.[0];
    const row = resp?.[1]?.[0];
    if (status?.code === 0 && row?.token) {
      rememberAccount();
      onLogin(row.token, row);
    } else if (status?.code === 6 || status?.code === 7) {
      rememberAccount();
      setError(null);
      setApproval({
        status: row?.status || (status.code === 7 ? 'rejected' : 'pending'),
        firstName: row?.firstName,
        rejectReason: row?.rejectReason,
        justSignedUp: false,
        checkedAt: new Date().toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' }),
      });
    } else {
      setApproval(null);
      setError(status?.msg || 'שגיאה, נסו שוב');
    }
  };

  const signUp = async () => {
    const resp = await API.signUp({
      firstName: form.firstName.trim(),
      lastName: form.lastName.trim(),
      phone: normalizePhone(form.phone),
      password: form.password,
      isKfarResident: form.isKfarResident,
    });
    const status = resp?.[0]?.[0];
    if (status?.code === 0) {
      rememberAccount();
      setApproval({ status: 'pending', firstName: resp?.[1]?.[0]?.firstName || form.firstName.trim(), justSignedUp: true });
    } else {
      setError(status?.msg || 'שגיאה, נסו שוב');
      // הטלפון כבר רשום → עוברים לכניסה עם אותו טלפון
      if (status?.code === 4) setMode('signin');
    }
  };

  const run = async (action) => {
    setLoading(true);
    setError(null);
    try { await action(); }
    catch (err) { setError(err.message || 'שגיאה, נסו שוב'); }
    finally { setLoading(false); }
  };

  const submit = (e) => {
    e.preventDefault();
    const v = validate();
    if (v) { setError(v); return; }
    run(mode === 'signup' ? signUp : signIn);
  };

  const backToSignIn = () => {
    setApproval(null);
    setError(null);
    setMode('signin');
  };

  const isSignup = mode === 'signup';

  return (
    <div style={s.page}>
      <div style={s.wrap}>
        <div style={s.brand}>
          <img src="/logo192.png" alt="" style={s.logo} />
          <h1 style={s.title}>זול בכפר</h1>
          <p style={s.subtitle}>השוואת מחירים בין הסופרים</p>
        </div>

        <div style={s.card}>
          {approval ? (
            <StatusCard approval={approval} loading={loading} onCheckAgain={() => run(signIn)} onBack={backToSignIn} />
          ) : (
          <>
          <div style={s.tabs} role="tablist">
            <button type="button" role="tab" aria-selected={!isSignup} style={{ ...s.tab, ...(!isSignup ? s.tabActive : null) }} onClick={() => switchMode('signin')}>כניסה</button>
            <button type="button" role="tab" aria-selected={isSignup} style={{ ...s.tab, ...(isSignup ? s.tabActive : null) }} onClick={() => switchMode('signup')}>הרשמה</button>
          </div>

          <form onSubmit={submit} noValidate>
            {error && <div style={s.error} role="alert">{error}</div>}

            {isSignup && (
              <div style={s.row}>
                <div style={s.field}>
                  <label style={s.label} htmlFor="au-first">שם פרטי</label>
                  <input id="au-first" style={s.input} value={form.firstName} onChange={set('firstName')} maxLength={32} autoComplete="given-name" autoFocus />
                </div>
                <div style={s.field}>
                  <label style={s.label} htmlFor="au-last">שם משפחה</label>
                  <input id="au-last" style={s.input} value={form.lastName} onChange={set('lastName')} maxLength={32} autoComplete="family-name" />
                </div>
              </div>
            )}

            <div style={s.field}>
              <label style={s.label} htmlFor="au-phone">טלפון</label>
              <input
                id="au-phone"
                type="tel"
                inputMode="tel"
                style={{ ...s.input, ...s.ltr }}
                value={form.phone}
                onChange={set('phone')}
                maxLength={20}
                autoComplete="tel"
                placeholder="050-0000000"
                autoFocus={!isSignup}
              />
            </div>

            <div style={s.field}>
              <label style={s.label} htmlFor="au-password">סיסמה</label>
              <input
                id="au-password"
                type="password"
                style={{ ...s.input, ...s.ltr }}
                value={form.password}
                onChange={set('password')}
                maxLength={64}
                autoComplete={isSignup ? 'new-password' : 'current-password'}
              />
              {isSignup && <div style={s.hint}>לפחות {MIN_PASSWORD} תווים</div>}
            </div>

            {isSignup && (
              <label style={s.check}>
                <input type="checkbox" style={s.checkbox} checked={form.isKfarResident} onChange={set('isKfarResident')} />
                אני תושב/ת כפר חב"ד
              </label>
            )}

            <button type="submit" style={s.submit} disabled={loading}>
              {loading ? 'רגע…' : isSignup ? 'הרשמה' : 'כניסה'}
            </button>
          </form>

          <div style={s.switch}>
            {isSignup
              ? <>כבר רשומים? <button type="button" style={s.link} onClick={() => switchMode('signin')}>כניסה</button></>
              : <>עוד לא רשומים? <button type="button" style={s.link} onClick={() => switchMode('signup')}>הרשמה מהירה</button></>}
          </div>
          </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
